import { getPaywallTitle } from "../helpers/paywalls";
import type { CheckoutProps } from "../types/CheckoutProps";

export const useCheckoutTitle = ({ paywall }: CheckoutProps) =>
  getPaywallTitle(paywall);
